import React from 'react';
import { Container } from 'reactstrap';

// Import Breadcrumb
import Addendums from "./Addendums";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const Addendum = () => {
    document.title = "Onfon Group Legal Dept";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumbs title="Menu" breadcrumbItem="Addendum Page" />
                    <div className="row">
                        <span width="100px"></span>
                        <Addendums />   
                        {/* <AddendumContent /> */}
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Addendum;